import React, { useState, useEffect } from "react";
import logoWeb from "assets/images/others/host-side-images/logo-web.png";
import { IoIosArrowDown } from "react-icons/io";
import NavbarDrawer from "../drawers/host-side/NavbarDrawer";
import { ReactComponent as Notification } from "assets/images/svgs/notification-red.svg";
import { ReactComponent as NotificationOpen } from "assets/images/svgs/NotificationOpen.svg";
import NotificatinDrawer from "../drawers/host-side/NotificatinDrawer";
import { NavLink, useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import useStore from "hooks/useStore";
import useAuth from "containers/auth/useHooks";
import { useSelector } from "react-redux";
const HostNavbar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [notificationDrawer, setNotificationDrawer] = useState<boolean>(false);
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const navigate = useNavigate();
  const { getUserProfilePic, getUserFullName, getToken } = useStore();
  const userProfilePic = getUserProfilePic();
  const userFullName = getUserFullName();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { getNotificationCount } = useAuth();
  const { notificationCount } = useSelector((state: any) => state.sharedReducer);
  
  const registeredData = useSelector(
    (state: any) => state.sharedReducer.registeredData
  );

    // Function to get border color based on subscription tier
    const getSubscriptionBorderColor = (subscriptionType: string) => {
      switch (subscriptionType) {
        case 'TIER_1':
          return 'border-[2px] border-white';
        case 'TIER_2':
          return 'border-[2px] border-gray-400'; // Silver
        case 'TIER_3':
          return 'border-[2px] border-yellow-400'; // Golden
        default:
          return 'border-[2px] border-white'; // Default
      }
    };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const toggleNotificationDrawer = () => {
    setNotificationDrawer(!notificationDrawer);

    setIsNotificationOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      // Use a small threshold to prevent flickering
      if (window.scrollY > 10) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Avoid calling notifications without a valid token (prevents 401 crashes during auth)
    const token = getToken();
    if (token) {
      getNotificationCount();
    }
  }, []);

  return (
    <div>
    {/* Navbar */}
    <nav
      className={`
        w-full
        bg-white
        transition-all duration-500 ease-in-out
        ${isSticky 
          ? 'fixed top-0 left-0 shadow-lg py-2 backdrop-blur-sm bg-white/95' 
          : 'relative shadow-none py-3 bg-white'
        }
      `}
      style={{ zIndex: 'calc(var(--z-navbar) + 1)' }}
    >
      <div className="container-navbar flex justify-between items-center transition-all duration-500 ease-in-out">
        <div className="flex items-center">
            <img
              onClick={() => {
                navigate(siteRoutes.home);
              }}
              src={logoWeb}
              alt="logo"
              className="h-8 cursor-pointer"
            />
          </div>
          <div className="flex items-center gap-5 sm:gap-10">
            {/* Links */}
            <div className="hidden md:flex items-center gap-5 sm:gap-10 ">
              <NavLink
                to="/communities"
                className={({ isActive }) =>
                  isActive ? "text-yellowText" : "text-darkBlueText"
                }
              >
                Community
              </NavLink>
              <NavLink
                to="/experiences"
                className={({ isActive }) =>
                  isActive ? "text-yellowText" : "text-darkBlueText"
                }
              >
                Experiences
              </NavLink>
              <button
                onClick={toggleNotificationDrawer}
                className="text-blackie relative"
              >
                {notificationCount > 0 && (
                  <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
                    {notificationCount}
                  </span>
                )}
                {isNotificationOpen ? <Notification /> :  <NotificationOpen />}
              </button>
            </div>

            <button
              onClick={toggleDrawer}
              className="flex items-center gap-2 text-blackie"
            >
               <img
              src={userProfilePic}
              alt="Profile"
              className={`w-8 h-8 rounded-full object-cover ${getSubscriptionBorderColor(registeredData?.user?.subscription?.product?.subscriptionType)}`}
            />
              {/* <UserIconNav /> */}
              <span className="hidden md:block text-primaryBlueText text-base capitalize">
                {userFullName}
              </span>
              <IoIosArrowDown className="text-blackie" />
            </button>
          </div>
        </div>
      </nav>

      {/* Drawer Components */}
      {drawerOpen && (
        <NavbarDrawer isOpen={drawerOpen} onClose={toggleDrawer} />
      )}
      {notificationDrawer && (
        <NotificatinDrawer
          isOpen={notificationDrawer}
          onClose={toggleNotificationDrawer}
        />
      )}
    </div>
  );
};

export default HostNavbar;
